// 1. Main InteractiveViewer.jsx - Orchestrates everything
import React, { useEffect, useRef, useState } from 'react';
import astroApi from '../api/astro';
import AladinViewer from './Viewer/AladinViewer';
import SearchPanel from './Viewer/SearchPanel';
import ConeSearchPanel from './Viewer/ConeSearchPanel';
import ObjectDetailsPanel from './Viewer/ObjectDetailsPanel';
import FloatingActionButtons from './Viewer/FloatingActionButtons';
import LoadingOverlay from './Viewer/LoadingOverlay';
import ErrorDisplay from './Viewer/ErrorDisplay';

const InteractiveViewer = () => {
  // Core Aladin state
  const aladinInstance = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isAladinReady, setIsAladinReady] = useState(false);

  // Panel visibility states
  const [showSearch, setShowSearch] = useState(true);
  const [showConeSearch, setShowConeSearch] = useState(false);

  // Selected object and coordinates
  const [selectedObject, setSelectedObject] = useState(null);
  const [selectedCoords, setSelectedCoords] = useState(null);

  // Astronomical tables
  const [tables, setTables] = useState([]);

  // Load tables on mount
  useEffect(() => {
    const loadTables = async () => {
      try {
        const astroTables = await astroApi.getAstroTables();
        setTables(astroTables || []);
      } catch (e) {
        console.error('Error loading astronomical tables:', e);
      }
    };
    loadTables();
  }, []);

  if (error) {
    return <ErrorDisplay error={error} onRetry={() => window.location.reload()} />;
  }

  return (
    <div className="fixed inset-0 bg-ui-light-background dark:bg-ui-dark-background z-10">
      {/* Header */}


      {/* Main Aladin Viewer */}
      <AladinViewer
        aladinInstance={aladinInstance}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        setError={setError}
        setIsAladinReady={setIsAladinReady}
        showConeSearch={showConeSearch}
        setSelectedCoords={setSelectedCoords}
        setSelectedObject={setSelectedObject}
      />

      {/* Loading Overlay */}
      {!isAladinReady && <LoadingOverlay />}

      {/* Search Panel */}
      <SearchPanel
        show={showSearch}
        setShow={setShowSearch}
        aladinInstance={aladinInstance}
      />

      {/* Cone Search Panel */}
      <ConeSearchPanel
        show={showConeSearch}
        setShow={setShowConeSearch}
        aladinInstance={aladinInstance}
        selectedCoords={selectedCoords}
        setSelectedCoords={setSelectedCoords}
        setSelectedObject={setSelectedObject}
        tables={tables}
      />

      {/* Floating Action Buttons */}
      <FloatingActionButtons
        isAladinReady={isAladinReady}
        showSearch={showSearch}
        setShowSearch={setShowSearch}
        showConeSearch={showConeSearch}
        setShowConeSearch={setShowConeSearch}
      />

      {/* Object Details Panel */}
      <ObjectDetailsPanel
        selectedObject={selectedObject}
        setSelectedObject={setSelectedObject}
        showSearch={showSearch}
        showConeSearch={showConeSearch}
      />
    </div>
  );
};

export default InteractiveViewer;